<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div
              class="card-header border-bottom p-1 d-flex justify-content-start flex-wrap"
            >
              <div
                class="btn-group m-1"
                role="group"
                data-toggle="buttons"
                v-for="status in typesUserStatus"
              >
                <button
                  class="btn btn-primary font-weight-bold border btn-outline-primary h5 mb-0 p-1 pl-3 pr-3"
                  :class="{
                    active: selectedView === status,
                    border: selectedView === status
                  }"
                  @click="selectedView = status"
                  type="button"
                >
                  {{ status.name }}
                </button>
              </div>
            </div>
            <div class="card-body">
              <member-list :typeUserStatus="selectedView" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberList from './MemberList.vue'
import { mapActions } from 'vuex'
export default {
  name: 'MemberLayout',
  components: {
    MemberList
  },
  data() {
    return {
      selectedView: {}, // Default view
      typesUserStatus: []
    }
  },
  mounted() {
    this.loadTypesUserStatus()
  },
  methods: {
    ...mapActions(['getData']),

    async loadTypesUserStatus() {
      const form = {
        url: 'type_user_status/all'
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typesUserStatus = response.data.map((item) => {
              return {
                id: item.id,
                name: item.name
              }
            })
            this.selectedView = this.typesUserStatus[0]
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }
}
</script>

<style>
.btn-new-user {
  border-radius: 20px;
  padding: 8px 14px !important;
  background-color: #1a438b;
}

.btn-new-user:hover {
  background-color: #0d2a57;
}
</style>
